<div
  class="grid w-full grid-cols-12 items-center gap-1 rounded bg-slate-200/75 px-1 hover:bg-french-blue-50"
>
  @if (iconPath) {
    <div class="grid">
      <svg-icon src="{{ iconPath }}" />
    </div>
  }
  <div class="col-span-5" [class]="colSpanClass">
    <p class="m-2 truncate text-base font-medium">
      {{ mainText }}
    </p>
  </div>
  @if (subText) {
    <div class="col-span-5">
      <h3 class="m-2 truncate">
        {{ subText }}
      </h3>
    </div>
  }
  <div class="grid">
    <span class="text-center" tooltipPosition="top" pTooltip="Remove">
      <div class="flex items-center justify-center">
        <button (click)="remove()">
          <svg-icon src="/assets/icons/general/close.svg" />
        </button>
      </div>
    </span>
  </div>
</div>
